import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getEventNotifierTitle = (record, translate) =>
  `${translate("app.event_notifier")} ${record.id} (${record.name})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getEventNotifierTitle} />}
    >
      <Form />
    </RaEdit>
  );
};

export default Edit;
